// Heatmap as a PNG for «Поделиться» and «Скопировать» (docs/heatmap/SPEC.md, decision 30): the card's title,
// the update line and the map's SVG drawn on a canvas.

const BACKGROUND = '#26272a';
const TITLE = '#f1f2f4';
const MUTED = '#8b8d93';
const PAD = 20;
const HEADER = 52;
const SCALE = 3;

function svgImage(svg, font) {
  const clone = svg.cloneNode(true);
  clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
  // Outside the page there is no CSS: the font is set on the copy, hover outlines are left out.
  clone.setAttribute('font-family', font);
  clone.querySelectorAll('[data-outline]').forEach((outline) => outline.remove());
  const xml = new XMLSerializer().serializeToString(clone);
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error('svg'));
    image.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(xml)}`;
  });
}

/**
 * @returns {Promise<Blob>} PNG of the map with its title and the update line
 */
export async function heatmapPng(svg, { title, subtitle }) {
  const width = Number(svg.getAttribute('width'));
  const height = Number(svg.getAttribute('height'));
  const font = getComputedStyle(document.body).fontFamily;
  const image = await svgImage(svg, font);

  const canvas = document.createElement('canvas');
  canvas.width = (width + PAD * 2) * SCALE;
  canvas.height = (height + HEADER + PAD * 2) * SCALE;
  const ctx = canvas.getContext('2d');
  ctx.scale(SCALE, SCALE);
  ctx.fillStyle = BACKGROUND;
  ctx.fillRect(0, 0, width + PAD * 2, height + HEADER + PAD * 2);

  ctx.textBaseline = 'alphabetic';
  ctx.fillStyle = TITLE;
  ctx.font = `600 17px ${font}`;
  ctx.fillText(title, PAD, PAD + 17);
  if (subtitle) {
    ctx.fillStyle = MUTED;
    ctx.font = `13px ${font}`;
    ctx.fillText(subtitle, PAD, PAD + 38);
  }
  ctx.drawImage(image, PAD, PAD + HEADER, width, height);

  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => (blob ? resolve(blob) : reject(new Error('png'))), 'image/png');
  });
}

// What the browser can do with an image: share a file (phones) and put a PNG on the clipboard.
export function canShareFiles() {
  try {
    return Boolean(navigator.canShare?.({ files: [new File([''], 'heatmap.png', { type: 'image/png' })] }));
  } catch {
    return false;
  }
}

export function canCopyImage() {
  return typeof window.ClipboardItem !== 'undefined' && Boolean(navigator.clipboard?.write);
}
